(module =>{
    "use strict";
    module.service('selectElementAndConvertService', function(this: $TSFixMe) {
        const self = this;

        self.pickElementFromArray = (coordinates: $TSFixMe, source: $TSFixMe, dataName: $TSFixMe) => {
            const {topLeft, bottomRight} = coordinates;
            const tempArr = [];
            for(let rowStart = topLeft.row, rowEnd = bottomRight.row; rowStart <= rowEnd; rowStart ++){
                const row = source[rowStart];
                let item = {data: []};
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'year' does not exist on type '{ data: ne... Remove this comment to see the full error message
                item.year = row.year;
                for(let colStart = topLeft.column, colEnd = bottomRight.column; colStart <= colEnd; colStart++){
                    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
                    item.data.push(row[dataName][colStart])
                }
                tempArr.push(item)
            }
            return tempArr;
        }

        self.setArithmeticAverage = (arr: $TSFixMe, properties: $TSFixMe, nestedProps: $TSFixMe) => {
            let item = {}
            let sumH = 0, sumC = 0;
            let tempHist = 0;
            let tempCorr = 0;
            for(let row = 0, max = arr.length; row < max; row++ ){

                let len =  arr[row].data.length;
                for(let col = 0; col < len; col++){
                    let elem = arr[row].data[col];
                    let propBase = elem && elem[properties[0]];
                    let propCorr = elem && elem[properties[1]];

                    if(propBase ||  propBase === 0){
                        sumH+= elem[properties[0]];
                        tempHist++
                    }

                    if(!nestedProps){
                        if(propCorr || propCorr === 0){
                            sumC += elem[properties[1]];
                            tempCorr ++;
                        }
                    } else {
                        let nestedElements = elem && elem[properties[1]]
                        if(nestedElements && nestedElements[nestedProps] || nestedElements && nestedElements[nestedProps] === 0){
                            sumC += nestedElements[nestedProps]
                            tempCorr++;
                        }else {
                            if(propBase || propBase === 0){
                                sumC += elem[properties[0]];
                                tempCorr++;
                            }
                        }

                    }
                }
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'baseAverage' does not exist on type '{}'... Remove this comment to see the full error message
                item.baseAverage = sumH / tempHist;
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'correctDataAverage' does not exist on ty... Remove this comment to see the full error message
                item.correctDataAverage = sumC / tempCorr;
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'baseSum' does not exist on type '{}'.
                item.baseSum = sumH;
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'correctDataSum' does not exist on type '... Remove this comment to see the full error message
                item.correctDataSum = sumC;
            }

            return [item];
        }

    })

})(angular.module('topline.services'));
